import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { CHART_COLORS } from '../utils/slideSchema';

const CORES = CHART_COLORS;

function toChartData(grafico) {
  const labels = grafico.labels || [];
  const valores = grafico.valores || [];
  return labels.map((label, i) => ({
    name: String(label),
    value: Number(valores[i]) || 0,
  }));
}

export default function SlideChart({ grafico, compact = false }) {
  const data = useMemo(() => toChartData(grafico), [grafico]);
  const tipo = grafico.tipo || 'bar';
  const height = compact ? 72 : 220;

  if (!data.length) return null;

  const chartBody = (() => {
    if (tipo === 'line') {
      return (
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(148,163,184,0.2)" />
          <XAxis dataKey="name" tick={{ fill: '#94a3b8', fontSize: compact ? 8 : 11 }} />
          <YAxis tick={{ fill: '#94a3b8', fontSize: compact ? 8 : 11 }} />
          {!compact && <Tooltip />}
          <Line type="monotone" dataKey="value" stroke="#38bdf8" strokeWidth={2} dot={{ r: 3 }} />
        </LineChart>
      );
    }
    if (tipo === 'pie' || tipo === 'doughnut') {
      return (
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={tipo === 'doughnut' ? (compact ? 14 : 40) : 0}
            outerRadius={compact ? 28 : 72}
            label={!compact}
          >
            {data.map((_, i) => (
              <Cell key={i} fill={CORES[i % CORES.length]} />
            ))}
          </Pie>
          {!compact && <Tooltip />}
          {!compact && <Legend wrapperStyle={{ color: '#cbd5e1', fontSize: 11 }} />}
        </PieChart>
      );
    }
    return (
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(148,163,184,0.2)" />
        <XAxis dataKey="name" tick={{ fill: '#94a3b8', fontSize: compact ? 8 : 11 }} />
        <YAxis tick={{ fill: '#94a3b8', fontSize: compact ? 8 : 11 }} />
        {!compact && <Tooltip />}
        <Bar dataKey="value" fill="#38bdf8" radius={[4, 4, 0, 0]} />
      </BarChart>
    );
  })();

  return (
    <Box
      sx={{
        bgcolor: 'rgba(255,255,255,0.04)',
        borderRadius: 1.5,
        p: compact ? 0.5 : 1.5,
        border: '1px solid rgba(148,163,184,0.15)',
        minWidth: 0,
      }}
    >
      {!compact && grafico.titulo && (
        <Typography variant="subtitle2" sx={{ color: '#e2e8f0', mb: 1, fontWeight: 600 }}>
          {grafico.titulo}
        </Typography>
      )}
      <ResponsiveContainer width="100%" height={height}>
        {chartBody}
      </ResponsiveContainer>
    </Box>
  );
}
